import {
  changeSubscriptionStatusForUserAPI,
  deleteUserAPI,
  lockUserAPI,
  PATCHChangeUserSubscriptionStatus,
  unlockUserAPI
} from '@myme/api';
import { DefaultPOSTorPATCHResType, sendRequest, UUID } from '@myme/utils';

const getUserIdRecord = (userId: UUID) => ({
  key: 'userId',
  value: userId
});

/* **** DELETE **** /admin/users/:userId */
export const deleteUser = async (userId: UUID) =>
  sendRequest<null, null>(deleteUserAPI, { args: [getUserIdRecord(userId)] });

/* **** PATCH **** /admin/users/:userId/lock-user */
export const lockUser = async (userId: UUID) =>
  sendRequest<null, null>(lockUserAPI, {
    args: [getUserIdRecord(userId)]
  });

/* **** PATCH **** /admin/users/:userId/unlock-user */
export const unlockUser = async (userId: UUID) =>
  sendRequest<null, null>(unlockUserAPI, {
    args: [getUserIdRecord(userId)]
  });

/* **** PATCH **** /admin/users/:userId/unlock-user */
export const changeUserSubscriptionStatus = async (userId: UUID, data: PATCHChangeUserSubscriptionStatus) =>
  sendRequest<DefaultPOSTorPATCHResType, PATCHChangeUserSubscriptionStatus>(changeSubscriptionStatusForUserAPI, {
    reqBody: data,
    args: [getUserIdRecord(userId)]
  });
